import request from '@/utils/request'

// 查询商品列表
export function loadProducts(params) {
  return request({
    url: '/api/yxTitle/products',
    method: 'get',
    params
  })
}

// 商品详情
export function loadProductDetail(params) {
  return request({
    url: '/api/yxTitle/product/detailByAdmin/' + params,
    method: 'get'
  })
}

// 查询栏目
export function loadYxTitle(params) {
  return request({
    url: '/api/yxTitle',
    method: 'get',
    params
  })
}

// 查看幻灯片
export function getCarousel(params) {
  return request({
    url: '/api/carousel',
    method: 'get',
    params
  })
}

// 查询首页模板
export function loadTemplate() {
  return request({
    url: 'https://gw.gdyfpt.com/api/template',
    method: 'get'
  })
}

// 酒店列表
export function loadHotelList(params) {
  return request({
    url: '/api/yxTitle/hotel',
    method: 'get',
    params
  })
}

// 餐厅列表
export function loadRestaList(params) {
  return request({
    url: '/api/yxTitle/resta',
    method: 'get',
    params
  })
}